import { Button, InlineLink } from '@carboncopyco/ui';
import { LEARNING_HUB_ARTICLE_LINKS } from '../consts';
import { useFolderManageAccess } from './FolderManageAccessContext';

export const FolderManageAccessControls = () => {
  const { submit, isDirty } = useFolderManageAccess();
  return (
    <div className="w-full mt-8">
      <div className="flex justify-between items-center w-full mt-4">
        <InlineLink
          label="Learn more about shared folders"
          className="mb-0.5 cursor-pointer"
          href={LEARNING_HUB_ARTICLE_LINKS['shared-folders']}
          target="_blank"
          rel="noopener noreferrer"
        />
        <Button
          label="Save"
          onClick={submit}
          disabled={!isDirty}
        />
      </div>
    </div>
  );
};
